import React from "react";
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { siteConstants } from "./constants";
import { GlobalStyle } from "./components/styles";
import LoginPage from "./components/pages/LoginPage";
import OrdersPage from "./components/pages/OrdersPage";
import CsReportsPage from "./components/pages/CsReportsPage";
import AssessmentReportPage from "./components/pages/AssessmentReportPage";
import TopTenTalentThemesPage from "./components/pages/TopTenTalentThemesPage";
import GuidanceDatabasePage from "./components/pages/GuidanceDatabasePage";
import CoupleGuidanceDatabasePage from "./components/pages/CoupleGuidanceDatabasePage";
import ThinkificDiscountCodesPage from "./components/pages/ThinkificDiscountCodesPage";
import PrivateRoute from "./components/routes/PrivateRoute";
import { authServices, axiosServices } from "./services";
import theme from "./theme";
import "./App.css";

const App = () => {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyle />
        <Helmet
          defaultTitle={ siteConstants.DEFAULT_TITLE }
          titleTemplate={ siteConstants.TITLE_TEMPLATE }
        />
        <BrowserRouter>
          <>
            <Routes>
              <Route path="/auth/login" element={
                authServices.isLoggedIn()
                  ? <Navigate to="/orders" />
                  : <LoginPage />
              } />
              <Route path="/" element={<PrivateRoute />} >
                <Route path="" element={<Navigate to="/orders" />} />
                <Route path="orders" element={<OrdersPage />} />
                <Route path="cs-reports" element={<CsReportsPage />} />
                <Route path="assessment-report" exact element={<AssessmentReportPage />} />
                <Route path="top-ten-talent-themes" element={<TopTenTalentThemesPage />} />
                <Route path="guidance-database" element={<GuidanceDatabasePage />} />
                <Route path="couple-guidance-database" element={<CoupleGuidanceDatabasePage />} />
                <Route path="thinkific-discount-codes" element={<ThinkificDiscountCodesPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
